<template>
  <tbody>
    <tr
      v-for="(item, i) in items"
      :key="i"
      class="text-xs-center hovereable cursor-default">
      <td>
        {{ formatDate(item.due_date, 'YYYY-MM-DD', 'DD/MM/YYYY') }}
      </td>
      <td>
        {{ new Intl.NumberFormat('es-VE').format(item.due_balance) }}
      </td>
      <td>
        {{ new Intl.NumberFormat('es-VE').format(item.invoiced_balance) }}
      </td>
    </tr>
  </tbody>
</template>

<script>
import moment from 'moment';

export default {
  props: ['items'],
  methods: {
    formatDate(date, typeFormat, toFormat) {
      return moment(date, typeFormat).format(toFormat);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customer/DuesList.vue